export const TAG_PINOUT_DEVICES = 'PinoutDevicesTag';
export const TAG_GET_QUOTE = 'GetQuote';
export const TAG_NOTIFICATIONS = 'NotificationsTag';
export const TAG_PROJECTS = 'ProjectsTag';
export const TAG_PROJECT = 'ProjectTag';
export const TAG_GET_PRODUCTS_OF_ROOMS_BY_FLOORS = 'ProductsOfRoomsByFloorsTag'
export const TAG_FLOOR_VIEW_PRODUCTS = 'FloorViewProductsTag'
export const TAG_GET_DEVICES = 'GetDevicesTag';
export const TAG_GET_USER_LABELS = 'GetUserLabelsTag';
export const TAG_USER_CUSTOM_ITEMS = 'UserCustomItemsTag';
export const TAG_STRIPE_SUBSCRIPTION = 'StripeSubscription';
export const TAG_FLOOR_ROOMS_AND_RELATED = 'FloorRoomsAndRelatedTag';
export const TAG_AUTOPLAN_TUTORIAL_STATUS = 'AutoplanTutorialStatusTag';
export const TAG_PROJECT_TREE = 'ProjectTreeTag';
export const TAG_PROJECT_QUOTE_DATA = 'ProjectQuoteDataTag';
export const TAG_BILLING_DATA = 'BillingDataTag';
export const TAG_MEASUREMENT_SYSTEM = 'MeasurementSystemTag';
export const TAG_PROJECT_USERS = 'ProjectUsersTag';
export const TAG_PROFILE_SETTINGS = 'ProfileSettingsTag';
export const TAG_USER_INFO = 'UserInfoTag';
export const TAG_PARTICIPANT_LISTS = 'ParticipantListsTag';
